var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.entries.length > 0)?_c('WhatsHappeningEntriesBox',{attrs:{"boxItemClass":"dark","entries":_vm.entries,"isCurrent":_vm.isCurrent,"tellAttendeeToGoToTheMeeting":true}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }